import React from 'react';
import { LayoutDashboard, Scroll, Wand2, ShoppingBag } from 'lucide-react';
export type Tab = 'dashboard' | 'zones' | 'add' | 'settings';
interface NavigationProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
}
export function Navigation({
  activeTab,
  onTabChange
}: NavigationProps) {
  const tabs = [{
    id: 'dashboard',
    icon: LayoutDashboard,
    label: 'Ledger'
  }, {
    id: 'zones',
    icon: Scroll,
    label: 'Revelio'
  }, {
    id: 'add',
    icon: Wand2,
    label: 'Conjure'
  }, {
    id: 'settings',
    icon: ShoppingBag,
    label: 'Scroll'
  }] as const;
  return <nav className="fixed bottom-0 left-0 right-0 bg-[#F5F0E1] border-t-2 border-[#C9A227] pb-safe z-50 shadow-[0_-4px_6px_-1px_rgba(114,47,55,0.1)]" data-id="element-35">
      <div className="flex justify-around items-center max-w-md mx-auto h-16 relative" data-id="element-36">
        {/* Decorative top line flourish */}
        <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#F5F0E1] via-[#C9A227] to-[#F5F0E1] opacity-50" data-id="element-37" />

        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        return <button key={tab.id} onClick={() => onTabChange(tab.id)} className={`flex flex-col items-center justify-center w-16 py-2 transition-all duration-300 ${isActive ? 'text-[#722F37] -translate-y-1' : 'text-[#2C2C2C]/60 hover:text-[#722F37]/80'}`} data-id="element-38">
              <div className={`relative p-1.5 rounded-full transition-all ${isActive ? 'bg-[#C9A227]/20' : ''}`} data-id="element-39">
                <Icon className={`w-6 h-6 ${isActive ? 'stroke-[2.5px]' : 'stroke-2'}`} data-id="element-40" />
                {isActive && <div className="absolute inset-0 bg-[#C9A227] rounded-full opacity-20 animate-ping" data-id="element-41" />}
              </div>
              <span className={`text-[10px] font-cinzel font-bold mt-1 tracking-wide ${isActive ? 'text-[#722F37]' : ''}`} data-id="element-42">
                {tab.label}
              </span>
            </button>;
      })}
      </div>
    </nav>;
}